import { apiClient } from './client';
import type { CityMember } from '../types';

export type AufgabenEntityType = 'verfahren' | 'anfrage' | 'inserat' | 'adresse';

export interface AssignmentChangeBody {
  new_user_id: number | null;
  context: string | null;
}

/** Zuständigkeit (Owner) — Mitglieder + Neuzuweisung. Aufgaben siehe api/aufgabe.ts. */
export const aufgabenApi = {
  members: async (): Promise<CityMember[]> => {
    const { data } = await apiClient.get<CityMember[]>('/aufgaben/members');
    return data;
  },

  assignVerfahren: async (id: number, body: AssignmentChangeBody) => {
    const { data } = await apiClient.patch(`/verfahren/${id}/zustaendig`, body);
    return data;
  },
  assignAnfrage: async (id: number, body: AssignmentChangeBody) => {
    const { data } = await apiClient.patch(`/anfragen/${id}/zustaendig`, body);
    return data;
  },
  assignInserat: async (id: number, body: AssignmentChangeBody) => {
    const { data } = await apiClient.patch(`/listings/${id}/zustaendig`, body);
    return data;
  },
  assignAdresse: async (id: number, body: AssignmentChangeBody) => {
    const { data } = await apiClient.patch(`/adressen/${id}/zustaendig`, body);
    return data;
  },
};

export function assignEntity(
  entityType: AufgabenEntityType,
  id: number,
  body: AssignmentChangeBody,
) {
  switch (entityType) {
    case 'verfahren':
      return aufgabenApi.assignVerfahren(id, body);
    case 'anfrage':
      return aufgabenApi.assignAnfrage(id, body);
    case 'inserat':
      return aufgabenApi.assignInserat(id, body);
    case 'adresse':
      return aufgabenApi.assignAdresse(id, body);
  }
}
